<template>
  <div class="gift-list-container">
    <MemberEmptyState v-if="props.gifts.length === 0" class="wd-py-6" :empty-text="props.emptyText" />
    <div v-else class="wd-py-6 wd-grid wd-grid-cols-1 wd-gap-3 md:wd-grid-cols-2 md:wd-gap-6">
      <component
        :is="props.cardComponent"
        v-for="gift in props.gifts"
        :key="gift.gift_id"
        :gift-info="gift"
        class="wd-border wd-border-solid wd-border-gray40"
      />
    </div>
    <p v-if="props.isEnd && props.gifts.length > 0" class="lord-more wd-my-4 wd-text-otempsm wd-text-gray60 wd-text-center">{{ $t('no_more') }}</p>
    <p v-if="!props.isEnd" v-intersect="{ handler: props.onIntersect }" />
  </div>
</template>

<script setup lang="ts">
import type { GiftListGift } from '@/types/api'

import MemberEmptyState from '@/components/member/MemberEmptyState.vue'

interface Props {
  gifts: GiftListGift[]
  isEnd: boolean
  emptyText: string
  cardComponent: Component
  onIntersect?: (isIntersecting: boolean, entries: IntersectionObserverEntry[], observer: IntersectionObserver) => void
}

const props = defineProps<Props>()
</script>
